import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

// Espelha o backend (sistemaadm): ImpressaoDoDiaRetorno.
// Endpoint de leitura: GET integracao/impressoes/dia?data=YYYY-MM-DD
// (auth por header Authorization + header `estabelecimento`, este ultimo injetado pelo
// interceptor de api.js a partir de estabelecimentoAtualCF — resolve a LOJA em uso).
// Somente leitura: lista TODAS as impressoes enviadas para a loja no dia (impressas ou
// nao). Nao consome a fila do /eventspolling.

export interface ImpressaoDoDia {
    id: number
    // Pedido associado (correlationId). Nulo em impressao avulsa (sem pedido).
    pedidoId: number | null
    // Hora em que a impressao foi enviada para a loja (ISO ou epoch, conforme o backend).
    dataCadastro: string | number | null
    // Tipo de impressao: PLACED, PRINT, PRINT1..n, CUPOM_FISCAL, CANCELLED, ...
    evento: string | null
    status: number | null
    statusPedido: number | null
    // 0 Delivery, 1 Retirada, 2 Mesa, 3 Kiosque.
    tipoPedido: number | null
}

export interface ErroApi {
    retornoErro: number
    mensagem: string
}

type RespostaErroRaw = { codErro?: number; retornoErro?: number; mensagem?: string }

function erroParaRespostaRaw(error: unknown): ErroApi {
    const axiosError = error as { message?: string; response?: { data?: unknown } }
    const data = axiosError.response?.data
    if (typeof data === "object" && data !== null) {
        const d = data as RespostaErroRaw
        const cod = d.retornoErro ?? d.codErro
        if (typeof cod === "number" && cod > 0) {
            return { retornoErro: cod, mensagem: d.mensagem ?? "" }
        }
    }
    if (axiosError.message === "Network Error") {
        return { retornoErro: 1, mensagem: "Verifique sua conexão!" }
    }
    return { retornoErro: 1, mensagem: axiosError.message || "Erro desconhecido" }
}

// Le as impressoes enviadas para a loja em uso (resolvida pelo header `estabelecimento`)
// num dia. `data` no formato YYYY-MM-DD; ausente = hoje (o backend assume hoje).
export const obterImpressoesDoDia = async function (
    authorization: string,
    data?: string
): Promise<ImpressaoDoDia[] | ErroApi> {
    try {
        const params = data ? `?data=${encodeURIComponent(data)}` : ""

        const response = await api
            .get<ImpressaoDoDia[] | RespostaErroRaw>(`integracao/impressoes/dia${params}`, {
                headers: { "Content-Type": "application/json", Authorization: authorization },
            })
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        const payload = response.data
        if (Array.isArray(payload)) {
            return payload
        }
        if (payload && typeof payload === "object") {
            const d = payload as RespostaErroRaw
            const cod = d.retornoErro ?? d.codErro
            if (typeof cod === "number" && cod > 0) {
                return { retornoErro: cod, mensagem: d.mensagem ?? "" }
            }
        }
        // Resposta vazia/nula: trata como lista vazia.
        return []
    } catch (error) {
        RegistrarLogErro(error, "obterImpressoesDoDia", data ?? "")
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}
